import React from "react";
import { Container, Row } from "react-bootstrap";
import useBlogs from "../../../../hooks/useBlogs";
import BlogCard from "../../../Blogs/BlogCard/BlogCard";
import style from "./HomeBlog.module.css";
import { Link } from "react-router-dom";

const HomeBlog = () => {
  const [blogs] = useBlogs();
  const selectedBlog = blogs.slice(0, 3);
  // console.log(selectedBlog);
  return (
    <div className={style.homeBlog__container}>
      <div className={style.homeBlog__title}>
        <h4>BLOGS</h4>
        <h1>
          <span style={{ color: "#DD1C63" }}>SOME</span> OF MY{" "}
          <span className={style.text__heilight}>ARTICLES</span>
        </h1>
      </div>
      <Container>
        <Row className="g-5">
          {selectedBlog.map((blog) => (
            <BlogCard key={blog.id} blog={blog}></BlogCard>
          ))}
        </Row>
      </Container>
      <div className={style.see__all__button}>
        <Link to="/blogs" >
          <button>See All Blogs</button>
        </Link>
      </div>
    </div>
  );
};

export default HomeBlog;
